const initialState = {
    gettingTempList: false,
    templateLists : null,
    rulesList : [],
    notifiDetails : null,
    alertStatusDetails: null,
    alertStatus: false,
}

export default initialState